export const selectFormFields = state => state.formFields && state.formFields.data;

export const selectFormFieldsAreLoading = state => state.formFields && state.formFields.isLoading;
